import * as React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FormManager, PageTitle, Section, Update, useCacheQuery, useCacheRecord } from 'gossamer-front-end';
import { Person, UserView } from 'cb-model';
import { getFilter } from 'gossamer-unified';

export const PersonUpdate = (): React.JSX.Element => {
  const params = useParams();
  const navigate = useNavigate();
  const record = useCacheRecord(Person, params.key, !params.key);
  const query = useCacheQuery(UserView, {
    where: {
      and: [getFilter('person_id', 'eq', params.key)],
    },
  });
  const user_id = query.data?.[0].id || undefined;

  return (
    <>
      <PageTitle verb="Update" entity={Person} />
      <FormManager
        compoundUrl="/main/~/person-update"
        handleCancel={() => user_id && navigate(`/admin/user/display/${user_id}`)}
        handleSuccess={() => user_id && navigate(`/admin/user/display/${user_id}`)}
        initialization={{
          main: {
            type: 'update-single',
            entity: Person,
            record,
            createOnNotFound: true,
          },
        }}
      >
        <Update valuesKey="main" entity={Person} title="Update Personal Details" />
      </FormManager>
    </>
  );
};
